<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="#" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <h2>Start-up Innovation</h2>
        <p><span class="versa">Start-ups</span> can be a very efficient way to transform ideas or technology into marketable products or life saving innovation when thinking about the protection of our environment. <span class="versa">Corporations</span> often lack the ability to
          innovate and change fundamentally whereas start-ups can quickly adopt new approaches, mindsets and
          requirements from a globalized world. One of these requirements is to live in harmony with our <span class="versa">Environment</span>
          whilst at the same time maintaining our standards of living. <span class="versa">Technology</span> and <span class="versa">Start-ups</span> can help overcome the
          current gap.</p>
        <p>Therefore we support the development of <span class="versa">Cleantech</span> start-ups in many ways:</p>

        <ul>
          <li>Mentoring</li>
          <li>Business Modelling</li>
          <li>Financing</li>
          <li>Energy Regulation</li>
        </ul>
        <h2>START-UP accelerator & contest activity</h2>
        <ul class="years">
          <li><span>2013-2015</span>Organization support & <a href="//www.youtube.com/user/StartupNightBerlin/feed?activity_view=1" target="_blank">moderation</a> Start-up Night Berlin (<a href="//www.startupnight.de/">Lange Nacht der Startups</a>)
          </li>
          <li><span>2015</span>Jury member <a href="//www.incense-accelerator.com/" target="_blank">INCENSe</a> Accelerator</li>
          <li><span>2015</span>Jury member and mentor <a href="//www.climate-kic.org/national-centres/berlin-germany/green-garage/" target="_blank">Climate KIC Green Garage Accelerator</a></li>
          <li><span>2015</span>Mentor <a href="//cleantech-innovationcenter.de/" target="_blank">Clean Tech Innovation Center</a></li>
          <li><span>2014</span>Jury member <a href="//www.eitdigital.eu/idea-challenge/about/" target="_blank">EIT Digital Idea Challenge</a> Smart Energy Systems</li>
          <li><span>2013</span>Jury member <a href="//www.telekom-innovation-contest.com/" target="_blank">Telekom Innovation Contest Smart Energy Systems</a></li>
        </ul>
        <p class="end">
        </p>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    methods: {
      back () {
        window.history.go(-1)
      }},
    data: function () {
      return {
        title: 'Start-Up Innovation'
      }
    },
    // Usage with context the component
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        return {
          inner: this.title
        }
      },
      meta: [
        { name: 'description', content: 'My description', id: 'desc' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Startup.vue?6cecf484